import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import Image from 'next/image'
import { useState } from 'react'
import { DealSyncSideBarModalConnect } from './SbModalConnect'
import styles from './styles/deal-sync.module.scss'

export const UnlockNetwork = () => {
  const [modalConnectOpen, setModalConnectOpen] = useState(false)

  return (
    <>
      <DealSyncSideBarModalConnect
        isOpen={modalConnectOpen}
        onClose={() => setModalConnectOpen(false)}
      />
      <div
        className={`p-16 bg-white rounded-20 flex flex-column gap-24 items-center ${styles['deal-sync-card']}`}
      >
        <div
          className="relative"
          style={{
            aspectRatio: '32 / 6',
            margin: '0 auto',
            height: '40px',
          }}
        >
          <Image
            src="/assets/creatorland-deal-sync-logo-2.png"
            alt="Logo Sync"
            style={{
              objectFit: 'contain',
              width: '100%',
            }}
            layout="fill"
          />
        </div>
        <Title
          sizeClass="text-15"
          className="text-center m-0"
          weightClass="font-bold"
          lineHeightClass="leading-23"
        >
          🚀 Unlock Your VIP Network’s Hidden Potential
        </Title>
        <Text variation="small" className="text-center" sizeClass="text-13">
          Connect your Gmail to uncover collaborators, creators, and key
          deal-makers from your inbox—your VIP network awaits!
        </Text>

        <div className="flex full-w justify-center">
          <button
            onClick={() => setModalConnectOpen(true)}
            className="bg-white rounded-50 cursor-pointer hover__bg-secondary  flex items-center justify-center gap-8 py-5 px-12 pl-18 border border-solid border-primary border-1"
          >
            <Image
              src="/assets/images/google-icon.svg"
              alt="Google"
              width={32}
              height={32}
            />
            <span className="font-bold text-14">Continue with Google</span>
          </button>
        </div>
      </div>
    </>
  )
}
